import React from "react";
import styled from "styled-components";

const BgImageContainerStyled = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background-color: "black";
`;

const BgImageStyled = styled.img`
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	zindex: 0;
`;

const MaskStyled = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 80%;
	background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
	zindex: 1;
`;

type Props = {
	alt: string;
	src: string;
} & React.HTMLAttributes<HTMLDivElement>;

const IMBgImage = ({ alt, src, ...rest }: Props) => {
	return (
		<BgImageContainerStyled {...rest}>
			<BgImageStyled src={src} alt={alt} />
			<MaskStyled />
		</BgImageContainerStyled>
	);
};

export default IMBgImage;
